<script lang="ts" setup>
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'

import { getLanguage } from '@/helpers/language-helper'
import {
  fetchLatestBlogStore,
  fetchSingleBlogStore,
  useBlogData,
  useBlogsSeo,
  useBlogsSeoIndexFollow,
  useSigleBlock
} from '@/services/Blogs/blogService'
import { useGlobalSeoMetaHandler } from '@/services/seoGlobalService'
import { getEnv } from '@/utils/environmentService'
import { localiseLinks } from '@/utils/localisedLinksService'
import { __ } from '@/utils/utils'

useBlogsSeo()
const topBlogs = ref<any>([])
const blog = ref<any>()
const route = useRoute()
const siteUrl = `${document.location.origin}/`
let lang: string = ''

onMounted(async () => {
  await fetchSingleBlogStore(route.params.slug as string)
  blog.value = useSigleBlock().value

  await fetchLatestBlogStore('')
  useGlobalSeoMetaHandler(useBlogsSeoIndexFollow())

  topBlogs.value = useBlogData().value
  window.scrollTo(0, 0)
  lang =
    localStorage.getItem('lang') !== '' &&
    localStorage.getItem('lang') !== 'undefined' &&
    localStorage.getItem('lang') !== 'en'
      ? localStorage.getItem('lang') + '/'
      : ''
})

watch(
  () => route.params.slug,
  async () => {
    await fetchSingleBlogStore(route.params.slug as string)
    blog.value = useSigleBlock().value
  },
  { deep: true }
)
const publishedDate = computed(() => {
  const date = new Date(blog?.value?.fields?.metadata[0]?.fields?.publish_date)

  return date.format('d.m.Y')
})
</script>
<template>
  <div class="bg-black">
    <div class="lg:pt-10 lg:pl-30 lg:pb-[141px] pb-20 flex flex-col lg:items-start items-center">
      <h1
        class="text-white lg:mt-[101px] mt-[37px] lg:h1-bold h3-bold self-center lg:self-start text-center lg:text-start px-[10px] lg:px-0"
        v-html="blog?.fields?.title"
      ></h1>
    </div>
  </div>
  <span class="flex justify-center w-full p-[1em]"
    >📅 {{ publishedDate }} 👤 {{ blog?.fields?.metadata?.[0]?.fields?.author }}</span
  >
  <div class="flex justify-center w-full">
    <div class="w-full max-w-[1440px] flex justify-center lg:mb-40 mb-20">
      <div class="w-full flex lg:flex-row flex-col max-w-[1200px] lg:gap-[60px] lg:mt-40">
        <div v-if="blog" class="max-w-[781px] px-[10px] lg:px-0">
          <div
            class="butter-wysiwyg"
            v-html="localiseLinks(blog?.fields?.content || '', getLanguage() || 'en', getEnv())"
          ></div>
          <div class="h6-bold mt-[50px] italic">
            {{
              __(
                'Disclaimer: The content of this article is intended for informational purposes only and should not be considered professional advice.'
              )
            }}
          </div>
        </div>
        <div class="flex flex-col lg:px-0 px-[10px] lg:mt-0 mt-20">
          <p class="mb-10 h3-bold">Top 5 Blogs</p>
          <a
            v-for="(blog, index) in topBlogs"
            :key="index"
            :href="siteUrl + lang + 'blog/' + blog?.fields?.seo_blog?.url_slug + '/'"
          >
            <div
              class="h6-regular pb-[10px] text-red-150"
              v-html="blog?.fields?.title !== '' ? blog?.fields?.title : 'blog'"
            ></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
::v-deep p {
  margin-bottom: 1.5em;
}

::v-deep h1,
::v-deep h2,
::v-deep h3,
::v-deep h4,
::v-deep h5,
::v-deep h6 {
  margin-top: 1.5em;
  margin-bottom: 1em;
}

::v-deep img {
  display: block;
  margin: 0px 1.5em;
}

::v-deep table {
  margin: 1.5em auto;
}
</style>
